import { Link, matchPath, useLocation } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Button } from '@mui/material';

export const GoToListButton = () => {
	const { pathname } = useLocation();
	const match = matchPath({ path: 'objects/:type', end: false }, pathname);

	if (!match) {
		return null;
	}

	const { params } = match;

	return (
		<Button
			component={Link}
			to={`/objects/${params.type}`}
			variant="text"
			startIcon={<ArrowBackIosNewIcon />}
		>
			Назад
		</Button>
	);
};
